/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DevSMS API v2
 * The dashboard's API (LLD §26.2), and the source Orval generates the
 * dashboard's client from (`dashboard/orval.config.ts`).
 *
 * This document describes the Go server as built. It is held to the code
 * by `test/contract`: the routes it lists are exactly the routes served,
 * in normal and in standalone mode (`TestV2Routes_MatchTheSpecInBothModes`),
 * and every answer the integration, contract and end-to-end tests provoke
 * is validated against the operation it documents
 * (`test/harness/apispec.Validating`). Spectral lints it with
 * `api/.spectral.yaml` (`make spec`).
 *
 * Conventions:
 *   - JSON is camelCase; enums are snake_case; times are RFC 3339 UTC.
 *   - Money is a whole number of XAF (ISO 4217 exponent 0) in a plain
 *     integer field, with a sibling `currency` field (always `XAF`) on
 *     the objects that carry one. There is no `{amount, currency}`
 *     wrapper object (DV-145).
 *   - Lists that can grow are keyset-paged: `?cursor=&limit=` in,
 *     `{items, nextCursor, hasMore}` out. A cursor is opaque and signed;
 *     a tampered one answers 422 `invalid_cursor`. Short, bounded lists
 *     answer `{items}`.
 *   - Errors are RFC 9457 `application/problem+json`. The machine code is
 *     the last segment of `type`, in kebab case
 *     (`…/problems/wallet-insufficient` is the code `wallet_insufficient`);
 *     `x-problem-codes` lists every code with its status. There is no
 *     separate `code` member (DV-145).
 *   - Authentication is a bearer access token from `POST /auth/login`
 *     (or Google, TOTP, refresh, invite). API keys are not accepted on
 *     v2; they are the v1 credential.
 *   - `x-permission` names the permission an operation requires (every
 *     one listed, when it is a list). Account routes (`/account/*`) also
 *     admit any staff user without it (DV-55). Every `/admin/*` route
 *     also refuses a staff user who has not enrolled TOTP (403
 *     `totp_enrolment_required`).
 *   - `x-step-up: true` marks an operation that needs an `X-Step-Up`
 *     token from `POST /auth/step-up`, under 5 minutes old (403
 *     `step_up_required` otherwise).
 *   - `x-idempotency: required` marks an operation that needs an
 *     `Idempotency-Key` header (422 `idempotency_key_required`); a
 *     repeat replays the first answer byte for byte with
 *     `Idempotent-Replay: true`. `x-idempotency: exempt` marks a write
 *     in a money area that deliberately takes none, and
 *     `x-idempotency-reason` says why.
 *   - `x-standalone: absent` marks an operation that is not mounted when
 *     `STANDALONE_MODE=true` (it answers 404 there).
 *   - `?lang=fr|en` (or `Accept-Language`) chooses the language of every
 *     problem's `detail` and of the PDFs; French is the default.
 *   - CORS admits one origin, the deployment's `DASHBOARD_URL`, with
 *     credentials (none when it is unset; never `*`). Preflights are
 *     answered `204` before authentication and rate limiting. Allowed
 *     request headers: `Authorization`, `Content-Type`,
 *     `Accept-Language`, `Idempotency-Key`, `X-Step-Up`, `X-Sdk-Client`;
 *     exposed: `Idempotent-Replay`, `RateLimit-Limit`,
 *     `RateLimit-Remaining`, `RateLimit-Reset`, `Retry-After`,
 *     `X-Request-Id`, `Content-Disposition`. (`/api/v1` keeps Nest's
 *     `enableCors()`: `Access-Control-Allow-Origin: *`, no credentials.)
 *
 * OpenAPI spec version: 2.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminApproveTransferBody,
  AdminListTransfersParams,
  AdminTransfer,
  AdminTransferPage,
  ConflictResponse,
  CreateTransferBody,
  ForbiddenResponse,
  InternalErrorResponse,
  NotFoundResponse,
  PayloadTooLargeResponse,
  ProofInput,
  ReasonInput,
  TooManyRequestsResponse,
  Transfer,
  TransferCreated,
  TransferUpload,
  UnauthorizedResponse,
  UnavailableResponse,
  UnprocessableResponse
} from '../model';

import { apiFetch } from '../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCreateTransferUrl = () => {




  return `/transfers`
}

/**
 * Opens the transfer with its reference, the bank details to pay, and
 * a presigned link to PUT the proof to (PDF, JPEG or PNG, at most
 * 5 MB, of exactly the declared type and size).
 * @summary Top up by bank transfer
 */
export const createTransfer = async (createTransferBody: CreateTransferBody, options?: Parameters<typeof apiFetch>[1]): Promise<TransferCreated> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<TransferCreated>(getCreateTransferUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createTransferBody)
  }
);}





export const getCreateTransferMutationKey = () => ['createTransfer'] as const;

export const getCreateTransferMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | TooManyRequestsResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTransfer>>, TError,CreateTransferMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTransfer>>, TError,CreateTransferMutationVariables, TContext> => {

const mutationKey = getCreateTransferMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTransfer>>, CreateTransferMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTransfer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTransferMutationResult = NonNullable<Awaited<ReturnType<typeof createTransfer>>>
    export type CreateTransferMutationBody = CreateTransferBody
    export type CreateTransferMutationError = UnauthorizedResponse | ForbiddenResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | TooManyRequestsResponse | InternalErrorResponse | UnavailableResponse
    export type CreateTransferMutationVariables = {data: CreateTransferBody}

    /**
 * @summary Top up by bank transfer
 */
export const useCreateTransfer = <TError = UnauthorizedResponse | ForbiddenResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | TooManyRequestsResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTransfer>>, TError,CreateTransferMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTransfer>>,
        TError,
        CreateTransferMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTransferMutationOptions(options), queryClient);
    }
    export const getGetTransferUrl = (id: string,) => {




  return `/transfers/${id}`
}

/**
 * @summary One bank transfer, with the bank details in force
 */
export const getTransfer = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<Transfer> => {

  return apiFetch<Transfer>(getGetTransferUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTransferQueryKey = (id: string,) => {
    return [
    `/transfers/${id}`
    ] as const;
    }


export const getGetTransferQueryOptions = <TData = Awaited<ReturnType<typeof getTransfer>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransfer>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTransferQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransfer>>> = ({ signal }) => getTransfer(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTransfer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTransferQueryResult = NonNullable<Awaited<ReturnType<typeof getTransfer>>>
export type GetTransferQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse


export function useGetTransfer<TData = Awaited<ReturnType<typeof getTransfer>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransfer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransfer>>,
          TError,
          Awaited<ReturnType<typeof getTransfer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTransfer<TData = Awaited<ReturnType<typeof getTransfer>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransfer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransfer>>,
          TError,
          Awaited<ReturnType<typeof getTransfer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTransfer<TData = Awaited<ReturnType<typeof getTransfer>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransfer>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One bank transfer, with the bank details in force
 */

export function useGetTransfer<TData = Awaited<ReturnType<typeof getTransfer>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransfer>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTransferQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRenewTransferUploadUrl = (id: string,) => {




  return `/transfers/${id}/upload`
}

/**
 * @summary A fresh link to upload the proof to
 */
export const renewTransferUpload = async (id: string,
    proofInput: ProofInput, options?: Parameters<typeof apiFetch>[1]): Promise<TransferUpload> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<TransferUpload>(getRenewTransferUploadUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proofInput)
  }
);}





export const getRenewTransferUploadMutationKey = () => ['renewTransferUpload'] as const;

export const getRenewTransferUploadMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renewTransferUpload>>, TError,RenewTransferUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof renewTransferUpload>>, TError,RenewTransferUploadMutationVariables, TContext> => {

const mutationKey = getRenewTransferUploadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renewTransferUpload>>, RenewTransferUploadMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  renewTransferUpload(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenewTransferUploadMutationResult = NonNullable<Awaited<ReturnType<typeof renewTransferUpload>>>
    export type RenewTransferUploadMutationBody = ProofInput
    export type RenewTransferUploadMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse
    export type RenewTransferUploadMutationVariables = {id: string;data: ProofInput}

    /**
 * @summary A fresh link to upload the proof to
 */
export const useRenewTransferUpload = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renewTransferUpload>>, TError,RenewTransferUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof renewTransferUpload>>,
        TError,
        RenewTransferUploadMutationVariables,
        TContext
      > => {
      return useMutation(getRenewTransferUploadMutationOptions(options), queryClient);
    }
    export const getSubmitTransferUrl = (id: string,) => {




  return `/transfers/${id}/submit`
}

/**
 * The upload is checked against the declared type and size; a refused proof is deleted (422 `proof_invalid`).
 * @summary Say the proof is uploaded, for review
 */
export const submitTransfer = async (id: string,
    proofInput: ProofInput, options?: Parameters<typeof apiFetch>[1]): Promise<Transfer> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<Transfer>(getSubmitTransferUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proofInput)
  }
);}





export const getSubmitTransferMutationKey = () => ['submitTransfer'] as const;

export const getSubmitTransferMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitTransfer>>, TError,SubmitTransferMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitTransfer>>, TError,SubmitTransferMutationVariables, TContext> => {

const mutationKey = getSubmitTransferMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitTransfer>>, SubmitTransferMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  submitTransfer(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitTransferMutationResult = NonNullable<Awaited<ReturnType<typeof submitTransfer>>>
    export type SubmitTransferMutationBody = ProofInput
    export type SubmitTransferMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse
    export type SubmitTransferMutationVariables = {id: string;data: ProofInput}

    /**
 * @summary Say the proof is uploaded, for review
 */
export const useSubmitTransfer = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitTransfer>>, TError,SubmitTransferMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitTransfer>>,
        TError,
        SubmitTransferMutationVariables,
        TContext
      > => {
      return useMutation(getSubmitTransferMutationOptions(options), queryClient);
    }
    export const getAdminListTransfersUrl = (params?: AdminListTransfersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/transfers?${stringifiedParams}` : `/admin/transfers`
}

/**
 * @summary Bank transfers, the review queue first
 */
export const adminListTransfers = async (params?: AdminListTransfersParams, options?: Parameters<typeof apiFetch>[1]): Promise<AdminTransferPage> => {

  return apiFetch<AdminTransferPage>(getAdminListTransfersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListTransfersInfiniteQueryKey = (params?: AdminListTransfersParams,) => {
    return [
    'infinite', `/admin/transfers`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminListTransfersQueryKey = (params?: AdminListTransfersParams,) => {
    return [
    `/admin/transfers`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListTransfersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminListTransfers>>, AdminListTransfersParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse>(params?: AdminListTransfersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminListTransfers>>, TError, TData, QueryKey, AdminListTransfersParams['cursor']>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListTransfersInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListTransfers>>, QueryKey, AdminListTransfersParams['cursor']> = ({ signal, pageParam }) => adminListTransfers({...params, ...((c) => c === undefined ? {} : { 'cursor': c })(pageParam ?? params?.['cursor'])}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminListTransfers>>, TError, TData, QueryKey, AdminListTransfersParams['cursor']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListTransfersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminListTransfers>>>
export type AdminListTransfersInfiniteQueryError = UnauthorizedResponse | ForbiddenResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse


export function useAdminListTransfersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminListTransfers>>, AdminListTransfersParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse>(
 params: undefined |  AdminListTransfersParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminListTransfers>>, TError, TData, QueryKey, AdminListTransfersParams['cursor']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListTransfers>>,
          TError,
          Awaited<ReturnType<typeof adminListTransfers>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListTransfersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminListTransfers>>, AdminListTransfersParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse>(
 params?: AdminListTransfersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminListTransfers>>, TError, TData, QueryKey, AdminListTransfersParams['cursor']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListTransfers>>,
          TError,
          Awaited<ReturnType<typeof adminListTransfers>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListTransfersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminListTransfers>>, AdminListTransfersParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse>(
 params?: AdminListTransfersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminListTransfers>>, TError, TData, QueryKey, AdminListTransfersParams['cursor']>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Bank transfers, the review queue first
 */

export function useAdminListTransfersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminListTransfers>>, AdminListTransfersParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse>(
 params?: AdminListTransfersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminListTransfers>>, TError, TData, QueryKey, AdminListTransfersParams['cursor']>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListTransfersInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminListTransfersQueryOptions = <TData = Awaited<ReturnType<typeof adminListTransfers>>, TError = UnauthorizedResponse | ForbiddenResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse>(params?: AdminListTransfersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListTransfers>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListTransfersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListTransfers>>> = ({ signal }) => adminListTransfers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListTransfers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListTransfersQueryResult = NonNullable<Awaited<ReturnType<typeof adminListTransfers>>>
export type AdminListTransfersQueryError = UnauthorizedResponse | ForbiddenResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse


export function useAdminListTransfers<TData = Awaited<ReturnType<typeof adminListTransfers>>, TError = UnauthorizedResponse | ForbiddenResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse>(
 params: undefined |  AdminListTransfersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListTransfers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListTransfers>>,
          TError,
          Awaited<ReturnType<typeof adminListTransfers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListTransfers<TData = Awaited<ReturnType<typeof adminListTransfers>>, TError = UnauthorizedResponse | ForbiddenResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse>(
 params?: AdminListTransfersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListTransfers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListTransfers>>,
          TError,
          Awaited<ReturnType<typeof adminListTransfers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListTransfers<TData = Awaited<ReturnType<typeof adminListTransfers>>, TError = UnauthorizedResponse | ForbiddenResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse>(
 params?: AdminListTransfersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListTransfers>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Bank transfers, the review queue first
 */

export function useAdminListTransfers<TData = Awaited<ReturnType<typeof adminListTransfers>>, TError = UnauthorizedResponse | ForbiddenResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse>(
 params?: AdminListTransfersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListTransfers>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListTransfersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminGetTransferUrl = (id: string,) => {




  return `/admin/transfers/${id}`
}

/**
 * @summary One transfer, with a 5-minute link to its proof
 */
export const adminGetTransfer = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<AdminTransfer> => {

  return apiFetch<AdminTransfer>(getAdminGetTransferUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetTransferQueryKey = (id: string,) => {
    return [
    `/admin/transfers/${id}`
    ] as const;
    }


export const getAdminGetTransferQueryOptions = <TData = Awaited<ReturnType<typeof adminGetTransfer>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetTransfer>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetTransferQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetTransfer>>> = ({ signal }) => adminGetTransfer(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetTransfer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetTransferQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetTransfer>>>
export type AdminGetTransferQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse


export function useAdminGetTransfer<TData = Awaited<ReturnType<typeof adminGetTransfer>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetTransfer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetTransfer>>,
          TError,
          Awaited<ReturnType<typeof adminGetTransfer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetTransfer<TData = Awaited<ReturnType<typeof adminGetTransfer>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetTransfer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetTransfer>>,
          TError,
          Awaited<ReturnType<typeof adminGetTransfer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetTransfer<TData = Awaited<ReturnType<typeof adminGetTransfer>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetTransfer>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One transfer, with a 5-minute link to its proof
 */

export function useAdminGetTransfer<TData = Awaited<ReturnType<typeof adminGetTransfer>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetTransfer>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetTransferQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminApproveTransferUrl = (id: string,) => {




  return `/admin/transfers/${id}/approve`
}

/**
 * Less than the total credits what was received, net of VAT (underpaid); more is refused (422 `transfer_overpaid`). Staff never approve their own transfer, nor one of a user they could not manage (403 `privilege_escalation`).
 * @summary Approve a transfer for the amount received, and credit it
 */
export const adminApproveTransfer = async (id: string,
    adminApproveTransferBody: AdminApproveTransferBody, options?: Parameters<typeof apiFetch>[1]): Promise<AdminTransfer> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<AdminTransfer>(getAdminApproveTransferUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminApproveTransferBody)
  }
);}





export const getAdminApproveTransferMutationKey = () => ['adminApproveTransfer'] as const;

export const getAdminApproveTransferMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminApproveTransfer>>, TError,AdminApproveTransferMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminApproveTransfer>>, TError,AdminApproveTransferMutationVariables, TContext> => {

const mutationKey = getAdminApproveTransferMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminApproveTransfer>>, AdminApproveTransferMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminApproveTransfer(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminApproveTransferMutationResult = NonNullable<Awaited<ReturnType<typeof adminApproveTransfer>>>
    export type AdminApproveTransferMutationBody = AdminApproveTransferBody
    export type AdminApproveTransferMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse
    export type AdminApproveTransferMutationVariables = {id: string;data: AdminApproveTransferBody}

    /**
 * @summary Approve a transfer for the amount received, and credit it
 */
export const useAdminApproveTransfer = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminApproveTransfer>>, TError,AdminApproveTransferMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminApproveTransfer>>,
        TError,
        AdminApproveTransferMutationVariables,
        TContext
      > => {
      return useMutation(getAdminApproveTransferMutationOptions(options), queryClient);
    }
    export const getAdminRejectTransferUrl = (id: string,) => {




  return `/admin/transfers/${id}/reject`
}

/**
 * @summary Reject a transfer
 */
export const adminRejectTransfer = async (id: string,
    reasonInput: ReasonInput, options?: Parameters<typeof apiFetch>[1]): Promise<AdminTransfer> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<AdminTransfer>(getAdminRejectTransferUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reasonInput)
  }
);}





export const getAdminRejectTransferMutationKey = () => ['adminRejectTransfer'] as const;

export const getAdminRejectTransferMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRejectTransfer>>, TError,AdminRejectTransferMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminRejectTransfer>>, TError,AdminRejectTransferMutationVariables, TContext> => {

const mutationKey = getAdminRejectTransferMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRejectTransfer>>, AdminRejectTransferMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminRejectTransfer(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRejectTransferMutationResult = NonNullable<Awaited<ReturnType<typeof adminRejectTransfer>>>
    export type AdminRejectTransferMutationBody = ReasonInput
    export type AdminRejectTransferMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse
    export type AdminRejectTransferMutationVariables = {id: string;data: ReasonInput}

    /**
 * @summary Reject a transfer
 */
export const useAdminRejectTransfer = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRejectTransfer>>, TError,AdminRejectTransferMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminRejectTransfer>>,
        TError,
        AdminRejectTransferMutationVariables,
        TContext
      > => {
      return useMutation(getAdminRejectTransferMutationOptions(options), queryClient);
    }
